import ActionTypes, {
  TAnswerInteractiveTest,
  TAnswerInteractiveVote,
  TAnswerInteractiveVoteGroup,
  TAnswerInteractiveVoteRating,
  TDataCheckDoneTest,
  TDataCheckDoneVote,
  TDataCheckDoneVoteGroup,
  TDataShowInteractive,
  TInteractiveState,
  TVoteEnd,
} from './types';
import { Actions, TDefRequest } from '../Action';
import { action } from 'typesafe-actions';

export const InteractiveActions = {
  setTest: (payload: TInteractiveState['test']) => action(ActionTypes.SET_TEST, payload),
  setVote: (payload: TInteractiveState['vote']) => action(ActionTypes.SET_VOTE, payload),
  setVoteRating: (payload: TInteractiveState['voteRating']) => action(ActionTypes.SET_VOTE_RATING, payload),
  setLink: (payload: TInteractiveState['link']) => action(ActionTypes.SET_LINK, payload),
  setTestResult: (payload: TInteractiveState['testResult']) => action(ActionTypes.SET_RESULT_TEST, payload),
  setVoteResult: (payload: TInteractiveState['voteResult']) => action(ActionTypes.SET_RESULT_VOTE, payload),
  setVoteRatingResult: (payload: TInteractiveState['voteRatingResult']) => action(ActionTypes.SET_RESULT_VOTE_RATING, payload),
  setRating: (payload: TInteractiveState['rating']) => action(ActionTypes.SET_RATING, payload),
  setVotesGroup: (payload: TInteractiveState['votesGroup']) => action(ActionTypes.SET_VOTES_GROUP, payload),
  setVotesRatingGroup: (payload: TInteractiveState['votesRatingGroup']) => action(ActionTypes.SET_VOTES_RATING_GROUP, payload),
  setEndVote: (payload: TVoteEnd) => action(ActionTypes.SET_END_VOTE, payload),
  setEndVoteRating: (payload: TVoteEnd) => action(ActionTypes.SET_END_VOTE_RATING, payload),
  setInteractive: (payload: string | null) => action(ActionTypes.SET_INTERACTIVE, payload),
  setRedirect: (payload: TInteractiveState['redirect']) => action(ActionTypes.SET_REDIRECT, payload),
  clearInteractive: () => action(ActionTypes.CLEAR_INTERACTIVE),
};

const ShowInteractiveAction = new Actions('SHOW_INTERACTIVE', ActionTypes);
export interface TypeShowInteractiveR extends TDefRequest {
  data: TDataShowInteractive;
}
export const ShowInteractive = {
  request: (payload: TypeShowInteractiveR) => ShowInteractiveAction.request(payload),
  success: () => ShowInteractiveAction.success({}),
  error: (message: string) => ShowInteractiveAction.error(message),
};

const SendTestAction = new Actions('SEND_TEST', ActionTypes);
export interface TypeSendTestR extends TDefRequest {
  data: TAnswerInteractiveTest;
}
export const SendTest = {
  request: (payload: TypeSendTestR) => SendTestAction.request(payload),
  success: (payload: TInteractiveState['doneTest']) => SendTestAction.success(payload || {}),
  error: (message: string) => SendTestAction.error(message),
};

const SendVoteAction = new Actions('SEND_VOTE', ActionTypes);
export interface TypeSendVoteR extends TDefRequest {
  data: TAnswerInteractiveVote;
}
export const SendVote = {
  request: (payload: TypeSendVoteR) => SendVoteAction.request(payload),
  success: (payload: TInteractiveState['doneVote']) => SendVoteAction.success(payload || {}),
  error: (message: string) => SendVoteAction.error(message),
};

const SendVoteGroupAction = new Actions('SEND_VOTE_GROUP', ActionTypes);
export interface TypeSendVoteGroupR extends TDefRequest {
  data: TAnswerInteractiveVoteGroup;
}
export const SendVoteGroup = {
  request: (payload: TypeSendVoteGroupR) => SendVoteGroupAction.request(payload),
  success: () => SendVoteGroupAction.success({}),
  error: (message: string) => SendVoteGroupAction.error(message),
};

const CheckDoneTestAction = new Actions('CHECK_DONE_TEST', ActionTypes);
export interface TypeDoneVoteR extends TDefRequest {
  data: TDataCheckDoneVote;
}
export const ChekDoneTest = {
  request: (payload: TypeDoneTestR) => CheckDoneTestAction.request(payload),
  success: (payload: TInteractiveState['doneTest']) => CheckDoneTestAction.success(payload || 0),
  error: (message: string) => CheckDoneTestAction.error(message),
};

const CheckDoneVoteAction = new Actions('CHECK_DONE_VOTE', ActionTypes);
export interface TypeDoneTestR extends TDefRequest {
  data: TDataCheckDoneTest;
}
export const CheckDoneVote = {
  request: (payload: TypeDoneVoteR) => CheckDoneVoteAction.request(payload),
  success: (payload: TInteractiveState['doneVote']) => CheckDoneVoteAction.success(payload || 0),
  error: (message: string) => CheckDoneVoteAction.error(message),
};

const CheckDoneVoteGroupAction = new Actions('CHECK_DONE_VOTE_GROUP', ActionTypes);
export interface TypeDoneVoteGroupR extends TDefRequest {
  data: TDataCheckDoneVoteGroup;
}
export const CheckDoneVoteGroup = {
  request: (payload: TypeDoneVoteGroupR) => CheckDoneVoteGroupAction.request(payload),
  success: (payload: TInteractiveState['doneVoteGroup']) => CheckDoneVoteGroupAction.success(payload || 0),
  error: (message: string) => CheckDoneVoteGroupAction.error(message),
};

const GetDefaultLinkAction = new Actions('GET_DEFAULT_LINK', ActionTypes);
export interface TypeGetDefaultLinkR extends TDefRequest {
  data: TDataShowInteractive;
}
export const GetDefaultLink = {
  request: (payload: TypeGetDefaultLinkR) => GetDefaultLinkAction.request(payload),
  success: (payload: TInteractiveState['link']) => GetDefaultLinkAction.success(payload || {}),
  error: (message: string) => GetDefaultLinkAction.error(message),
};

const SendVoteRatingAction = new Actions('SEND_VOTE_RATING', ActionTypes);
export interface TypeSendVoteRatingR extends TDefRequest {
  data: TAnswerInteractiveVoteRating;
}
export const SendVoteRating = {
  request: (payload: TypeSendVoteRatingR) => SendVoteRatingAction.request(payload),
  success: (payload: TInteractiveState['doneVoteRating']) => SendVoteRatingAction.success(payload || {}),
  error: (message: string) => SendVoteRatingAction.error(message),
};

const CheckDoneVoteRatingAction = new Actions('CHECK_DONE_VOTE_RATING', ActionTypes);
export interface TypeDoneVoteRatingR extends TDefRequest {
  data: TDataCheckDoneVote;
}
export const CheckDoneVoteRating = {
  request: (payload: TypeDoneVoteRatingR) => CheckDoneVoteRatingAction.request(payload),
  success: (payload: TInteractiveState['doneVoteRating']) => CheckDoneVoteRatingAction.success(payload || {}),
  error: (message: string) => CheckDoneVoteRatingAction.error(message),
};

const CheckDoneVoteRatingGroupAction = new Actions('CHECK_DONE_VOTE_RATING_GROUP', ActionTypes);
export interface TypeDoneVoteRatingGroupR extends TDefRequest {
  data: TDataCheckDoneVoteGroup;
}
export const CheckDoneVoteRatingGroup = {
  request: (payload: TypeDoneVoteRatingGroupR) => CheckDoneVoteRatingGroupAction.request(payload),
  success: (payload: TInteractiveState['doneVoteRatingGroup']) => CheckDoneVoteRatingGroupAction.success(payload || {}),
  error: (message: string) => CheckDoneVoteRatingGroupAction.error(message),
};

const SendVoteRatingGroupAction = new Actions('SEND_VOTE_RATING_GROUP', ActionTypes);
export interface TypeSendVoteRatingGroupR extends TDefRequest {
  data: TAnswerInteractiveVoteGroup;
}
export const SendVoteRatingGroup = {
  request: (payload: TypeSendVoteRatingGroupR) => SendVoteRatingGroupAction.request(payload),
  success: () => SendVoteRatingGroupAction.success({}),
  error: (message: string) => SendVoteRatingGroupAction.error(message),
};
